import { SPEAKER_ID_PREFIX } from '@/shared/lib/constants/speakerIdPrefix';

export const getDisplayingSpeakerId = (str: string) => {
  const speakerIdMatch = str.match(new RegExp(`${SPEAKER_ID_PREFIX}(\\d+)`, 'i'));
  const speakerId = speakerIdMatch && speakerIdMatch[1];
  // we need to add 1 to each speaker because it's bad to show to user "Speaker 0"
  return `Speaker ${speakerId ? parseInt(speakerId) + 1 : ''}`;
};
